import { render, staticRenderFns } from "./modalTerima.vue?vue&type=template&id=31037400"
import script from "./modalTerima.vue?vue&type=script&lang=js"
export * from "./modalTerima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports